import PropTypes from 'prop-types';

export const SuccessModalPropTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export const SuccessModalDefaultProps = {
  isOpen: false,
  onClose: undefined,
};

export const SuccessContainerPropTypes = { onClose: PropTypes.func.isRequired };
